export default __webpack_public_path__ + "static/media/menuL_on_icon_04.2528f827.png";